import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy, ElementRef, AfterViewInit, OnChanges } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { LoginService } from '@serengeti/serengeti-common';
import { MenuToggleService } from '../../service/toggle.service';
import { environment } from '../../../../../environments/environment';
import { NavigationService } from 'src/app/layout/navigation/navigation.service';


@Component({
	selector: 'app-menu-sub-side',
	templateUrl: './subside.component.html',
	styleUrls: ['./subside.component.scss']
})
export class MenuSubSideComponent implements OnInit, OnDestroy {

	@Input() toggleMode = false;
	@Input() root = true;
	@Input() scrollTop = null;

	visibleMenus = [];

	_menu: any;
	@Input() set menu(_menu: any) {
		this._menu = _menu;

		if (_menu) {
			this.visibleMenus = _menu.children.filter((submenu: any) => submenu.visible === 'Visible');
		} else {
			this.visibleMenus.length = 0;
		}
	}
	get menu() {
		return this._menu;
	}

	@ViewChild(MatMenuTrigger, {static: false}) trigger: MatMenuTrigger;

	@Output() topMenuSelected = new EventEmitter<any>();
	
	selectedMenu: any;
	
	@Output() sidenavClose = new EventEmitter();
	
	routeSubscription: Subscription;
	
	menuNavigation = '';
	
	submenu$: Observable<any>;
	
	@Output() selectedMenuEvent = new EventEmitter<any>();

	constructor(
		private navigationService: NavigationService,
		private loginService: LoginService,
		private router: Router,
		private menuToggleService: MenuToggleService,
		private el: ElementRef,
	) {
		this.routeSubscription = this.router.events.pipe(
			filter((event: RouterEvent) => event instanceof NavigationEnd)
		).subscribe(() => {
			this.sidenavClose.emit();
		});

		this.menuNavigation = environment.menuNavigation;
	}

	getLoginService(): LoginService {
		return this.loginService;
	}

	triggerToggleState(state: boolean) {
		this.menuToggleService.subject.next({
			state: state,
			element: this.el
		});
	}

	ngOnInit() {
		setTimeout(() => {
			if (this.el.nativeElement && this.el.nativeElement.offsetTop) {
				const height = Math.min(400, 25 + 48 * this.visibleMenus.length);
				const clientHeight = Math.max(document.documentElement.clientHeight, this.el.nativeElement.offsetParent.clientHeight);

				if ((height + parseInt(this.el.nativeElement.offsetTop) - 80) > clientHeight) {
					this.scrollTop = (clientHeight - height + 80) + 'px';
				} else {
					this.scrollTop = null;
				}
			}
		}, 100);
	}

	ngOnDestroy() {
		if (this.menuNavigation !== 'sidepopup' && this.root) {
			document.documentElement.style.setProperty('--documentSideMenuWidth', '0');
		}
		this.menuToggleService.subject.next({
			state: false,
			element: this.el
		});

		if (this.routeSubscription) {
			this.routeSubscription.unsubscribe();
		}
	}

	showMenus(menu: any): void {
		this.topMenuSelected.emit(menu);
		if (this.trigger) {
			this.trigger.openMenu();
		}
	}
	
	public onSidenavClose = () => {
		this.sidenavClose.emit();
	}

	public doSelectMenu(menu: any) {
		if (this.selectedMenu === menu) {
			this.selectedMenu = null;
			this.selectedMenuEvent.emit();
		} else {
			this.selectedMenu = menu;
		}
	}

	public getMenuLink(menu: any) {
		if (menu.menuUrl.includes('{') && menu.menuUrl.includes('}')) {
			return menu.menuUrl.replace('{loginId}', this.loginService.getLoginId());
		} else {
			return menu.menuUrl;
		}
	}

	public selectSubMenu(_: any) {
		this.selectedMenuEvent.emit();
	}

	public goRouter(submenu: any) {
		const startsWith = submenu.menuUrl.startsWith('http');
		const url = submenu.menuUrl;
		const title = submenu.defaultName;

		this.selectSubMenu(submenu);
		
		if (startsWith) {
			window.open(url)
		} else {
			this.router.navigate(['/main', { outlets: { content: url }}], { queryParams: { title: title }});
		}
	}

}
